import React, { useCallback, useEffect, useState } from 'react'
import BarChartDisplay from '../../Common/BarChart/BarChartDisplay'
import Header from '../../Common/Header/Header'
import '../../Common/Common/Style.css'
import { ActiveUserPercentageDat, Dataset, GradeDataType, LoaderDataType, SearchDataTye, StatusDataType, StudentDataType, TableGradeDataType, TotalCountDataType, UserData, UserDataType } from './DashboardInterface'
import { checkGradeName, createGrade, deleteGrade, GetAllGrade, GetAllStudentByOffsetAndCount, GetAllUserByOffsetAndCount, GetTotalPercentageData, GetWeeklyPercentageData, searchGrade, searchStudent, searchUser, updateGrade } from '../../../api/dashboard'
import { Role } from './DashboardEnum'
import { useAppDispatch, useAppSelector } from '../../../hooks'
import { getNewAccessToken } from '../../../api/auth'
import { setToken } from '../../../reducers/UserSplice'
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
import { Tooltip } from "react-tooltip";
import { Form, Modal, Spinner } from 'react-bootstrap'
import { IdAndName, MessageDataType } from '../../Common/Common/CommonInterface'
import ConfirmationPopup from '../../Common/MessagePopup/ConfirmationPopup'
import SuccessPopup from '../../Common/MessagePopup/SuccessPopup'
import FailurePoup from '../../Common/MessagePopup/FailurePopup'

const Dashboard = () => {
  const dispatch = useAppDispatch()

  const [gradeName, setGradeName] = useState<string>("")



  const [gradeLoading, setGradeLoading] = useState(false);

  const [dropDownList, setDropDownList] = useState<{ grade: IdAndName[] }>({
    grade: []
  })

  const [confirmationPopupData, setConfirmationPopupData] = useState({
    title: '',
    message: '',
    descriptions: '',
    acceptText: '',
    cancelText: '',
    onAccept: () => { },
    onCancel: () => { },
  });
  const [show, setShow] = useState(false);
  const handleClose = useCallback(() => setShow(false), []);

  const [validated, setValidated] = useState<boolean>(false);
  const [message, setMessage] = useState<MessageDataType>({
    errorMessage: [],
    successMessage: "",
    failureMessage: ""
  })
  const [openAddGradePopup, setOpenAddGradePopup] = useState<boolean>(false);

  const [editGradeData, setEditGradeData] = useState<GradeDataType>({
    id: "",
    gradeName: ""
  })

  const [totalCount, setTotalCount] = useState<TotalCountDataType>({
    studentTotalCount: 0,
    userTotalCount: 0,
    gradeTotalCount: 0
  });

  const [dataset, setDataset] = useState<Dataset[]>([])

  const [percentageData, setPercentageData] = useState<ActiveUserPercentageDat>({
    totalUser: 0,
    lastSevenDayCount: 0,
    lastSevenDataPercent: 0
  });

  const [tableData, setTableData] = useState<UserData>({
    studentData: [],
    userData: [],
    gradeData: []
  });


  const [itemsPerPage] = useState(10);
  const [searchtext, setSearchText] = useState<SearchDataTye>({
    studentSearchText: "",
    userSearchText: "",
    gradeSearchText: ""
  });

  const [searchFilter, setSearchFilter] = useState<StatusDataType>({
    studentRole: "",
    userRole: "",
    userGrade: { id: "", name: "" },
    studentGrade: { id: "", name: "" }

  })


  const [currentUserPage, setCurrentUserPage] = useState(1);
  const indexOfLastUserItem = currentUserPage * itemsPerPage;
  const indexOfFirstUserItem = indexOfLastUserItem - itemsPerPage;

  const [currentStudentPage, setCurrentStudentPage] = useState(1);
  const indexOfLastStudentItem = currentStudentPage * itemsPerPage;
  const indexOfFirstStudentItem = indexOfLastStudentItem - itemsPerPage;

  const [currentGradePage, setCurrentGradePage] = useState(1);
  const indexOfLastGradeItem = currentGradePage * itemsPerPage;
  const indexOfFirstGradeItem = indexOfLastGradeItem - itemsPerPage;

  const { access_token, refresh_token } = useAppSelector((state) => state.user.token)
  const [loading, setLoading] = useState<LoaderDataType>({
    barChartLoader: false,
    userLoader: false,
    studentLoader: false,
    gradeLoader: false
  });




  const getAuthorizedToken = async () => {
    try {
      await getNewAccessToken({ refreshToken: refresh_token }).then((newTokenResponse) => {
        const { data, statusCode } = newTokenResponse;
        if (statusCode === 200) {
          dispatch(setToken({
            access_token: data.accessToken,
            refresh_token: data.refreshToken
          }))
        }
      })
    } catch (error: any) {
      console.error("Something went wrong in getting new access Token :: ", error)
    }
  }


  const downloadUserTable = async () => {
    let totalUsersData: UserDataType[] = [];

    if (searchtext.userSearchText || searchFilter.userRole || searchFilter.userGrade.id) {
      setLoading({ ...loading, userLoader: true })
      await searchUser(searchtext.userSearchText, searchFilter.userRole, "", "0", String(totalCount.userTotalCount), access_token)
        .then((searchUserData) => {
          const { data, statusCode } = searchUserData;
          if (statusCode === 200) {
            const UserformattedData: UserDataType[] = data.data.map((user: any) => ({
              id: user.id,
              // fname: user.full_name,
              email: user.email,
              grade: { gradeId: user.grade ? user.grade.id : "-", gradeName: user.grade ? user.grade.name : "-" },
              school_district: { id: user.school_district ? user.school_district.id : "-", name: user.school_district ? user.school_district.name : "-" },
              // username: user.username,
              role: user.role === "TEACHER" ? Role.TEACHER : Role.PARENT,
              createdAt: user.created
            }));

            totalUsersData = UserformattedData


            const userDoc = new jsPDF({ orientation: "landscape" });

            // Get the table without the last column
            autoTable(userDoc, {
              // head: [[
              //   "S.No.", "FULL NAME", "EMAIL", "USERNAME", "ROLE", "SCHOOL DISTRICT", "GRADE", "CREATED AT"  // Exclude action column
              // ]],
              head: [[
                "S.No.", "EMAIL", "ROLE", "SCHOOL DISTRICT", "GRADE", "CREATED AT"  // Exclude action column
              ]],
              body: totalUsersData.map((user: UserDataType, index: number) => [
                index + 1,
                // user.fname,
                user.email,
                // user.username,
                user.role,
                user.school_district.name,
                user.grade.gradeId === "1" ? user.grade.gradeName.substring(0, 6) : user.grade.gradeName,
                new Date(user.createdAt).toLocaleDateString()
              ]),
            });

            userDoc.save(`users.pdf`);
          }
        })
        .catch(error => {
          console.error("Handle Search Error :: ", error);
        })
        .finally(() => {
          setLoading(prevLoading => ({
            ...prevLoading,
            userLoader: false
          }));
        });
    } else {
      await GetAllUserByOffsetAndCount("0", String(totalCount.userTotalCount)).then((allUsersData) => {

        let totalUsersData: UserDataType[] = [];
        const { data, statusCode } = allUsersData;
        if (statusCode === 200) {
          const UserformattedData: UserDataType[] = data.data.map((user: any) => ({
            id: user.id,
            // fname: user.full_name,
            email: user.email,
            grade: { gradeId: user.grade ? user.grade.id : "-", gradeName: user.grade ? user.grade.name : "-" },
            school_district: { id: user.school_district ? user.school_district.id : "-", name: user.school_district ? user.school_district.district : "-" },
            // username: user.username,
            role: user.role === "TEACHER" ? Role.TEACHER : Role.PARENT,
            createdAt: user.created
          }));

          totalUsersData = UserformattedData


          const userDoc = new jsPDF({ orientation: "landscape" });

          // Get the table without the last column
          autoTable(userDoc, {
            // head: [[
            //   "S.No.", "FULL NAME", "EMAIL", "USERNAME", "ROLE", "SCHOOL DISTRICT", "GRADE", "CREATED AT"  // Exclude action column
            // ]],
            head: [[
              "S.No.", "EMAIL", "ROLE", "SCHOOL DISTRICT", "GRADE", "CREATED AT"  // Exclude action column
            ]],
            body: totalUsersData.map((user: UserDataType, index: number) => [
              index + 1,
              // user.fname,
              user.email,
              // user.username,
              user.role,
              user.school_district.name,
              user.grade.gradeId === "1" ? user.grade.gradeName.substring(0, 6) : user.grade.gradeName,
              new Date(user.createdAt).toLocaleDateString()
            ]),
          });

          userDoc.save(`users.pdf`);
        }
      })
    }




  };

  const downloadStudentTable = async () => {
    let totalStudentData: StudentDataType[] = [];

    if (searchtext.studentSearchText || searchFilter.studentGrade.id) {
      await searchStudent(searchtext.studentSearchText, searchFilter.studentRole, searchFilter.studentGrade.id, "0", String(totalCount.studentTotalCount), access_token)
        .then((searchTribeData) => {
          const { data, statusCode } = searchTribeData;
          if (statusCode === 200) {
            const studentFormattedData: StudentDataType[] = data.data.map((student: any) => ({
              id: student.id,
              fname: student.full_name,
              schoolDistrict: {
                id: student.school_district ? student.school_district.id : "", name: student.school_district ? student.school_district.name.toLowerCase()
                  .split(" ")
                  .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ") : ""
              },
              grade: { gradeId: student.grade ? student.grade.id : "", gradeName: student.grade ? student.grade.name : "" },
              username: student.username,
              role: Role.STUDENT,
              createdAt: student.created
            }))
            totalStudentData = studentFormattedData;


            const studentDoc = new jsPDF({ orientation: "landscape" });

            // Get the table without the last column
            autoTable(studentDoc, {
              head: [[
                "S.No.", "STUDENT NAME", "SCHOOL DISTRICT", "GRADE", "USERNAME", "ROLE", "CREATED AT"  // Exclude action column
              ]],
              body: totalStudentData.map((student: StudentDataType, index: number) => [
                index + 1,
                student.fname,
                student.schoolDistrict.name.toLowerCase().split(" ").map((word: any) => word.charAt(0).toUpperCase() + word.slice(1)).join(" "),
                student.grade.gradeId === "1" ? student.grade.gradeName.substring(0, 6) : student.grade.gradeName,
                student.username,
                student.role,
                new Date(student.createdAt).toLocaleDateString()
              ]),
            });

            studentDoc.save(`students.pdf`);
          }

        })
        .catch(error => {
          console.error("Handle Search Error :: ", error);
        })
        .finally(() => {
          setLoading(prevLoading => ({
            ...prevLoading,
            studentLoader: false
          }));
        });
    } else {
      await GetAllStudentByOffsetAndCount("0", String(totalCount.studentTotalCount)).then((allStudentData) => {
        const { data, statusCode } = allStudentData;
        if (statusCode === 200) {
          const studentFormattedData: StudentDataType[] = data.data.map((student: any) => ({
            id: student.id,
            fname: student.full_name,
            schoolDistrict: {
              id: student.school_district ? student.school_district.id : "", name: student.school_district ? student.school_district.district.toLowerCase()
                .split(" ")
                .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ") : ""
            },
            grade: { gradeId: student.grade ? student.grade.id : "", gradeName: student.grade ? student.grade.name : "" },
            username: student.username,
            role: Role.STUDENT,
            createdAt: student.created
          }))
          totalStudentData = studentFormattedData;


          const studentDoc = new jsPDF({ orientation: "landscape" });

          // Get the table without the last column
          autoTable(studentDoc, {
            head: [[
              "S.No.", "STUDENT NAME", "SCHOOL DISTRICT", "GRADE", "USERNAME", "ROLE", "CREATED AT"  // Exclude action column
            ]],
            body: totalStudentData.map((student: StudentDataType, index: number) => [
              index + 1,
              student.fname,
              student.schoolDistrict.name.toLowerCase().split(" ").map((word: any) => word.charAt(0).toUpperCase() + word.slice(1)).join(" "),
              student.grade.gradeId === "1" ? student.grade.gradeName.substring(0, 6) : student.grade.gradeName,
              student.username,
              student.role,
              new Date(student.createdAt).toLocaleDateString()
            ]),
          });

          studentDoc.save(`students.pdf`);
        }
      })
    }




  };

  const getAllUser = async (offset: number) => {
    setLoading({
      ...loading,
      userLoader: true,
    });
    try {
      await GetAllUserByOffsetAndCount(String(offset), String(itemsPerPage)).then((allUserResponse: any) => {
        const { data, statusCode } = allUserResponse;
        if (statusCode === 200) {
          handleUserData(data, "Users");
        } else if (statusCode === 401) {
          getAuthorizedToken()

        }
      })
    } catch (error: any) {
      setLoading({
        ...loading,
        userLoader: false
      })

    }

  }

  const getAllStudents = async (offset: number) => {
    setLoading({ ...loading, studentLoader: true })
    try {
      await GetAllStudentByOffsetAndCount(String(offset), String(itemsPerPage)).then((allStudentResponse: any) => {
        const { data, statusCode } = allStudentResponse;
        if (statusCode === 200) {
          handleUserData(data, "Student");
        } else if (statusCode === 401) {
          getAuthorizedToken();
        }
      })
    } catch (error: any) {
      setLoading({
        ...loading,
        studentLoader: false
      })
    }


  }

  const getAllGrades = async () => {
    try {
      setLoading({
        ...loading,
        gradeLoader: true
      })
      await GetAllGrade(access_token).then((allGradeResponse) => {
        const { data, statusCode } = allGradeResponse;
        if (statusCode === 200) {
          handleGradeData(data);
          setDropDownList((prevState: any) => ({
            ...prevState,
            grade: data.data.map((grade: any) => ({
              id: grade.id,
              name: grade.name
            }))
          }));
        }
      })
    } catch (error: any) {

    }
  }


  useEffect(() => {
    console.log("Table Data ><> ", tableData)
  }, [tableData])

  const handleUserData = (UserData: any, userType: string) => {

    try {
      const { data, count } = UserData;
      const isUser = userType === "Users";

      setTotalCount((prev) => ({
        ...prev,
        [isUser ? "userTotalCount" : "studentTotalCount"]: count
      }));
      if (isUser) {
        const UserformattedData: UserDataType[] = data.map((user: any) => ({
          id: user.id,
          fname: user.full_name,
          email: user.email,
          grade: { gradeId: user.grade ? user.grade.id : "", gradeName: user.grade ? user.grade.name : "" },
          school_district: {
            id: user.school_district ? user.school_district.id : "", name: user.school_district ? user.school_district.district.toLowerCase()
              .split(" ")
              .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ") : ""
          },
          username: user.username,
          role: user.role === "TEACHER" ? Role.TEACHER : Role.PARENT,
          createdAt: user.created
        }));

        setTableData((prev) => ({
          ...prev,
          userData: UserformattedData
        }));
      } else {
        const studentFormattedData: StudentDataType[] = data.map((student: any) => ({
          id: student.id,
          fname: student.full_name,
          schoolDistrict: {
            id: student.school_district ? student.school_district.id : "", name: student.school_district ? student.school_district.district.toLowerCase()
              .split(" ")
              .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ") : ""
          },
          grade: { gradeId: student.grade ? student.grade.id : "", gradeName: student.grade ? student.grade.name : "" },
          username: student.username,
          role: Role.STUDENT,
          createdAt: student.created
        }))
        setTableData((prev) => ({
          ...prev,
          studentData: studentFormattedData
        }));

      }
    } finally {
      setLoading({
        ...loading,
        userLoader: false,
        studentLoader: false
      })
    }

  };



  const handlePagination = async (pageNumber: number, direction: string, userRole: string) => {
    if (userRole === "User") {
      if (pageNumber < 1 || pageNumber > Math.ceil(totalCount.userTotalCount / itemsPerPage)) {
        return; // Prevent navigation to invalid pages
      }
      try {
        setLoading({
          ...loading,
          studentLoader: false,
          userLoader: true
        });
        if (direction === "right") {
          if (pageNumber <= Math.ceil(totalCount.userTotalCount / itemsPerPage)) {
            setCurrentUserPage(pageNumber);
          }
        } else {
          if (pageNumber >= 1) {
            setCurrentUserPage(pageNumber);
          }
        }
      } catch (error: any) {

      }

    } else if (userRole === "Student") {
      if (pageNumber < 1 || pageNumber > Math.ceil(totalCount.studentTotalCount / itemsPerPage)) {
        return; // Prevent navigation to invalid pages
      }




      try {
        setLoading({
          ...loading,
          userLoader: false,
          studentLoader: true
        });
        if (direction === "right") {
          if (pageNumber <= Math.ceil(totalCount.studentTotalCount / itemsPerPage)) {
            setCurrentStudentPage(pageNumber);
          }
        } else {
          if (pageNumber >= 1) {
            setCurrentStudentPage(pageNumber);
          }
        }
      } catch (error: any) {

      }

    }

  };



  const getUserPercentageData = async () => {
    await GetTotalPercentageData().then((totalUserData) => {
      const { statusCode, data } = totalUserData;
      if (statusCode === 200) {
        setPercentageData({
          totalUser: Number(data.totalUsers),
          lastSevenDayCount: data.lastSevenDaysUsersCount,
          lastSevenDataPercent: Number(data.lastSevenDaysUsersPercentage)
        })

      }
    })
  }

  const getWeeklyPercentageData = async () => {
    try {
      await GetWeeklyPercentageData().then((WeeklytotalData) => {
        const { statusCode, data } = WeeklytotalData;
        if (statusCode === 200) {
          // const formattedData : Dataset = data.map((data))
          const formattedData: Dataset[] = data.map((item: any) => ({
            day: item.day,
            newUser: item.users, // Convert "users" to "newUser"
          }));
          setDataset(formattedData);

        }
      })
    } finally {
      setLoading({
        ...loading,
        barChartLoader: false
      })
    }

  }


  const handleStudentSearch = async (event: any, name: string, SearchText: string, status: string) => {
    setLoading(prevLoading => ({
      ...prevLoading,
      studentLoader: true
    }));

    setCurrentStudentPage(1);
    if (name !== "showAll") {
      if (name === "status") {
        setSearchFilter(prevActiveRole => ({
          ...prevActiveRole,
          studentRole: ""
        }));
      } else if (name === "searchText") {
        setSearchText(prevSearchText => ({
          ...prevSearchText,
          studentSearchText: event.target.value
        }));
      }
    } else {
      setSearchText(prevSearchText => ({
        ...prevSearchText,
        studentSearchText: ""
      }));
      setSearchFilter(prevActiveRole => ({
        ...prevActiveRole,
        studentRole: ""
      }));
    }
  };

  // Use useEffect to trigger API call when searchText or searchFilter changes
  useEffect(() => {
    const fetchSearchData = async () => {
      setLoading({
        ...loading,
        studentLoader: true
      })
      if (searchtext.studentSearchText || searchFilter.studentRole || searchFilter.studentGrade.id) {
        await searchStudent(searchtext.studentSearchText, searchFilter.studentRole, searchFilter.studentGrade.id, String(indexOfFirstStudentItem), String(itemsPerPage), access_token).then((searchTribeData) => {
          const { data, statusCode } = searchTribeData;

          if (statusCode === 200) {
            handleUserData(data, "Student");
          } else if (statusCode === 401) {
            getAuthorizedToken();
          }
        })
          .catch(error => {
            console.error("Handle Search Error :: ", error);
          })
          .finally(() => {
            setLoading(prevLoading => ({
              ...prevLoading,
              studentLoader: false
            }));
          });
      } else {
        getAllStudents(indexOfFirstStudentItem);
      }
    }

    fetchSearchData()
  }, [searchtext.studentSearchText, searchFilter.studentRole, searchFilter.studentGrade.id, currentStudentPage]);


  const handleUserSearch = async (event: any, name: string, SearchText: string, role: string) => {
    setLoading(prevLoading => ({
      ...prevLoading,
      userLoader: true
    }));

    setCurrentUserPage(1);

    if (name !== "showAll") {
      if (name === "role") {
        setSearchFilter(prevActiveRole => ({
          ...prevActiveRole,
          userRole: role
        }));
      } else if (name === "searchText") {
        setSearchText(prevSearchText => ({
          ...prevSearchText,
          userSearchText: event.target.value
        }));
      }
    } else {
      setSearchText(prevSearchText => ({
        ...prevSearchText,
        userSearchText: ""
      }));
      setSearchFilter(prevActiveRole => ({
        ...prevActiveRole,
        userRole: ""
      }));
    }
  };

  // Use useEffect to trigger API call when searchText or searchFilter changes
  useEffect(() => {
    const fetchUserData = async () => {
      setLoading({ ...loading, userLoader: true });
      if (searchtext.userSearchText || searchFilter.userRole || searchFilter.userGrade.id) {
        await searchUser(searchtext.userSearchText, searchFilter.userRole, searchFilter.userGrade.id, String(indexOfFirstUserItem), String(itemsPerPage), access_token).then((searchUserData) => {
          const { data, statusCode } = searchUserData;
          if (statusCode === 200) {
            handleUserData(data, "Users");
          } else if (statusCode === 401) {
            getAuthorizedToken();
          }
        })
          .catch(error => {
            console.error("Handle Search Error :: ", error);
          })
          .finally(() => {
            setLoading(prevLoading => ({
              ...prevLoading,
              userLoader: false
            }));
          });
      } else {
        getAllUser(indexOfFirstUserItem);
      }
    }

    fetchUserData()



  }, [searchtext.userSearchText, searchFilter.userRole, searchFilter.userGrade.id, currentUserPage]);


  const removeFilterBox = async (filterType: string) => {

    try {
      setLoading({
        ...loading,
        userLoader: true
      });
      setCurrentUserPage(1);


    } catch (error) {
      setLoading({
        ...loading,
        userLoader: false
      });
    }
    const resetStatus = () => {
      setSearchFilter({
        ...searchFilter,
        userRole: ""
      });
    };

    const resetUserGrade = () => {
      setSearchFilter({
        ...searchFilter,
        userGrade: { id: "", name: "" }
      });
    }
    const performSearch = async (searchText: string, role: string, gradeId: string) => {
      try {

        await searchUser(searchText, role, gradeId, String(indexOfFirstUserItem), String(itemsPerPage), access_token).then((searchTribeData) => {
          const { data, statusCode } = searchTribeData;
          if (statusCode === 200) {
            handleUserData(data, "Users");
          } else if (statusCode === 401) {
            getAuthorizedToken();
          }
        });
      } catch (error) {
        console.error("Error during tribe search:", error);
        setLoading({
          ...loading,
          userLoader: true
        });
      }
    };

    if (filterType === "activeRole") {
      resetStatus();
    } else if (filterType === "activeUserGrade") {
      resetUserGrade();
    }

  };



  useEffect(() => {
    getAllUser(indexOfFirstUserItem)
    getAllStudents(indexOfFirstStudentItem)
    getAllGrades()
    getUserPercentageData()
    getWeeklyPercentageData()
  }, [])

  const handleCancel = () => {
    setOpenAddGradePopup(false);
    setValidated(false)
    setEditGradeData({
      id: "",
      gradeName: ""
    })
  }

  const handleGradeData = (gradeData: any) => {
    setLoading({
      ...loading,
      gradeLoader: true
    })
    try {
      setTotalCount((prev) => {
        const updatedData = { ...prev }

        updatedData.gradeTotalCount = gradeData.totalCount

        return updatedData
      })
      const formattedGradeData: TableGradeDataType[] = gradeData.data.map((grade: any) => {
        let unitCount = 0;

        grade.lessons.forEach((lesson: any) => {
          unitCount += lesson.unitCount;
        });

        return {
          id: grade.id,
          gradeName: grade.name,
          lessonCount: grade.lessonCount,
          unitCount: unitCount,
          createdAt: grade.created
        };
      });

      setTableData((prev) => {
        const updatedData = { ...prev };
        updatedData.gradeData = formattedGradeData
        return updatedData;
      })
    } finally {
      setLoading({
        ...loading,
        gradeLoader: false
      })
    }

  }

  const handleGradeInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    setEditGradeData({
      ...editGradeData,
      gradeName: value
    })
  }

  const handleAddGrade = () => {
    setEditGradeData({
      id: "",
      gradeName: ""
    })
    setMessage({
      errorMessage: [],
      successMessage: "",
      failureMessage: ""
    })
    setOpenAddGradePopup(true);
  }

  const handleGradeSearch = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setLoading({
      ...loading,
      gradeLoader: true
    })
    setSearchText({
      ...searchtext,
      gradeSearchText: e.target.value
    });
    try {
      if (e.target.value) {
        await searchGrade(e.target.value, access_token).then((searchResponse) => {
          const { data, statusCode } = searchResponse;



          if (statusCode === 200) {
            handleGradeData(data)
          }
        })
      } else {

        await GetAllGrade(access_token).then((allGradeResponse) => {
          const { data, statusCode } = allGradeResponse;

          if (statusCode === 200) {
            handleGradeData(data)
          }
        })
      }

    } catch (error: any) {

    }

  }

  const handleGradeEdit = (grade: TableGradeDataType) => {
    setEditGradeData({
      id: grade.id,
      gradeName: grade.gradeName
    })
    setGradeName(grade.gradeName)
    setMessage({
      errorMessage: [],
      successMessage: "",
      failureMessage: ""
    })
    setOpenAddGradePopup(true);
  }

  const handleGradeDelete = async (grade: TableGradeDataType) => {
    setShow(true)
    setConfirmationPopupData({
      title: `Are you sure you want to delete ${grade.gradeName}?`,
      message: "This action cannot be undone.",
      descriptions: "",
      acceptText: "Yes",
      cancelText: "Cancel",
      onAccept: async () => {
        setShow(false);
        setLoading({ ...loading, gradeLoader: true })
        try {
          await deleteGrade(grade.id, access_token).then((deleteResponse) => {
            const { statusCode } = deleteResponse;
            if (statusCode === 200) {
              setMessage({
                ...message,
                successMessage: "Grade deleted successfully!"
              })
            } else if (statusCode === 401) {
              getAuthorizedToken();
              setMessage({
                ...message,
                failureMessage: "Authorization token expired. Try again!"
              })
            }
          })
        } catch (error: any) {
          if (error.response && error.response.data && typeof error.response.data === "string") {
            setMessage({
              ...message,
              failureMessage: error.response.data.message,
            });
          } else {
            setMessage({
              ...message,
              failureMessage: "Something went wrong. Please try again",
            });
          }
        } finally {
          setTimeout(() => {
            setMessage((prev => {
              const updatedData = { ...prev };
              updatedData.errorMessage = [];
              updatedData.failureMessage = "";
              updatedData.successMessage = ""
              return updatedData
            }))

          }, 2500)
          getAllGrades()
        }


      },
      onCancel: handleClose,
    })

  }



  useEffect(() => {
    if (!openAddGradePopup) {
      getAllGrades()
    }
  }, [openAddGradePopup])

  const handleSubmit = async () => {
    const { id, gradeName } = editGradeData;
    setGradeLoading(true)
    if (!gradeName.trim()) {
      setValidated(true);
      setGradeLoading(false);
      return false;
    }

    await checkGradeName(id, gradeName, access_token).then(async (checkResponse) => {
      const { data, statusCode } = checkResponse;
      if (statusCode === 200) {
        if (editGradeData.id) {
          try {
            updateGrade({ name: gradeName, id: Number(id) }, access_token).then((updateResponse) => {
              const { data, statusCode } = updateResponse;
              if (statusCode === 200) {
                setMessage({
                  ...message,
                  successMessage: "Grade updated successfully!"
                })
              } else if (statusCode === 401) {
                getAuthorizedToken();
                setMessage({
                  ...message,
                  failureMessage: "Authorization token expired. Try again!"
                })
              }

            })
          } catch (error: any) {
            if (error.response && error.response.data && typeof error.response.data === "string") {
              setMessage({
                ...message,
                failureMessage: error.response.data.message,
              });
            } else {
              setMessage({
                ...message,
                failureMessage: "Something went wrong. Please try again",
              });
            }
          } finally {


            setTimeout(() => {
              setMessage((prev => {
                const updatedData = { ...prev };
                updatedData.errorMessage = [];
                updatedData.failureMessage = "";
                updatedData.successMessage = ""
                return updatedData
              }))



            }, 2500)

            setGradeLoading(false);
            handleCancel()
            getAllGrades()
            setLoading({
              ...loading,
              gradeLoader: true
            })

          }

        } else {
          try {
            await createGrade({ name: editGradeData.gradeName }, access_token).then((createResponse) => {
              const { data, statusCode } = createResponse;
              if (statusCode === 200) {
                setMessage({
                  ...message,
                  successMessage: "Grade added successfully!"
                })
              } else if (statusCode === 401) {
                getAuthorizedToken();
                setMessage({
                  ...message,
                  failureMessage: "Authorization token expired. Try again!"
                })
              }
            })
          } catch (error: any) {
            if (error.response && error.response.data && typeof error.response.data === "string") {
              setMessage({
                ...message,
                failureMessage: error.response.data.message,
              });
            } else {
              setMessage({
                ...message,
                failureMessage: "Something went wrong. Please try again",
              });
            }
          } finally {


            setTimeout(() => {
              setMessage((prev => {
                const updatedData = { ...prev };
                updatedData.errorMessage = [];
                updatedData.failureMessage = "";
                updatedData.successMessage = ""
                return updatedData
              }))



            }, 2500)

            setGradeLoading(false);
            handleCancel()
            getAllGrades()
            setLoading({
              ...loading,
              gradeLoader: true
            })

          }

        }
      } else if (statusCode === 409) {
        setGradeLoading(false);
        setMessage({
          ...message,
          errorMessage: ["Grade already exists."]
        })
      }
    })
  }

  return (
    <div className="dashboard d-flex">
      <Header />
      <div className="rightContainer">
        {message.successMessage && (
          <SuccessPopup message={message.successMessage} />
        )}

        {message.failureMessage && (
          <FailurePoup message={message.successMessage} />
        )}


        <Modal show={openAddGradePopup} onHide={handleCancel}>
          <Modal.Header>
            <Modal.Title>{editGradeData.id ? gradeName : "Add Grade"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form noValidate validated={validated} className="create-tribe__form" >
              <div className="form-group text-start">
                <h6>Grade Name <span className="text-danger">*</span></h6>
                <input type="text" name="gradeName" className="form-control" placeholder="Grade Name" value={editGradeData.gradeName} maxLength={30} onFocus={() => setMessage(prev => ({ ...prev, errorMessage: [], successMessage: "", failureMessage: "" }))} onChange={handleGradeInputChange} required />
                <div className="invalid-feedback" style={{ textAlign: "center" }}>Please provide a valid grade name.</div>
              </div>
              <div className="form-actions">
                <div className="row">
                  <div className="col-md-6">
                    <div className="btn-group w-100">
                      <button type="button" className="btn btn-save btnPurple" style={{ color: "white" }} onClick={handleSubmit} disabled={gradeLoading} >
                        {gradeLoading ? (
                          <React.Fragment>
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                            Saving...
                          </React.Fragment>
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <button type="button" className="btn btn-cancel btnBorder" style={{ color: "#230048" }} onClick={handleCancel}>Cancel</button>
                  </div>
                </div>
              </div>

            </Form>
          </Modal.Body>
        </Modal>



        <div className="header-container">

          <h2 className="page-title text-center">Dashboard</h2>
        </div>
        <div className="row">
          <div className='col-md-8 mb-4'>
            <div className="pCard" style={{ height: 200, padding: '12px 24px' }}>
              {loading.barChartLoader ?
                <div className=" d-flex align-items-center">
                  <div className="loader mx-auto"></div>
                </div>

                :
                (dataset.length > 0 ?
                  // <UserGrowthChart />
                  <BarChartDisplay ResponseDataset={dataset} />
                  :
                  <div className=" d-flex align-items-center">
                    <div className="loader mx-auto"></div>
                  </div>
                )}
            </div>
          </div>
          <div className='col-md-4'>
            <div className="pCard" style={{ height: 200, padding: "12px 24px" }}>
              <h5 className='mb-5 studentStatTitle' style={{ color: "#333232" }}>Total Users</h5>
              <div className="row justify-content-center">
                <div className="col-auto">
                  <img src="./assets/images/factura.png" alt="" width="80" />
                </div>
                <div className="col-auto">

                  {percentageData.lastSevenDayCount > 0 ?
                    <div className="studentStats">
                      <h4>{percentageData.lastSevenDayCount}</h4>
                      <div className="positive">
                        {percentageData.lastSevenDataPercent > 0 && <img src="./assets/images/arrow-trend-up.svg" alt="" />}  {Math.ceil(percentageData.lastSevenDataPercent)}%
                      </div>
                    </div>
                    :
                    <div className=" d-flex align-items-center">
                      <div className="loader mx-auto"></div>
                    </div>
                  }

                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="pCard mb-4">

          <div className="topAction align-items-center">
            <h5 style={{ color: "#333232" }}>Users</h5>
            <div className="dropdown statusDrop ms-auto" >
              <button className="dropdown-toggle" type="button" id="dropdownUserRole" data-bs-toggle="dropdown" aria-expanded="false" >
                {/* {searchFilter.userRole === "All" ? "Role" : searchFilter.userRole === "Teacher" ? "Teacher" : searchFilter.userRole === "Parent" ? "Parent" : "Role"} */}
                Role
              </button>
              <ul className="dropdown-menu" aria-labelledby="dropdownUserRole">
                <li><button className={`dropdown-item ${searchFilter.userRole === "All"} ? "active" : ""`} name="role" onClick={(e: any) => handleUserSearch(e, "showAll", searchtext.userSearchText, searchFilter.userRole)}>All</button></li>
                <li><button className={`dropdown-item ${searchFilter.userRole === "Teacher"} ? "active" : ""`} name="role" value="Teacher" onClick={(e: any) => handleUserSearch(e, "role", searchtext.userSearchText, "Teacher")} >Teacher</button></li>
                {/* <li><button className={`dropdown-item ${searchFilter === "Draft"} ? "active" : ""`} onClick={() => {setSearchFilter("Draf"); handleStatusFilter('0')}}>Draft</button></li> */}
                <li><button className={`dropdown-item ${searchFilter.userRole === "Parent"} ? "active" : ""`} name="role" value="Parent" onClick={(e: any) => handleUserSearch(e, "role", searchtext.userSearchText, "Parent")} >Parent</button></li>
              </ul>

              {searchFilter.userRole &&
                <span className="badge rounded-pill" style={{ marginLeft: '1rem', background: '#782ACB' }}>{searchFilter.userRole}
                  <span className='ps-2' style={{ cursor: 'pointer' }}><img src="./assets/images/xmark-solid.svg" alt="" onClick={() => setSearchFilter({ ...searchFilter, userRole: "" })} /></span></span>
              }

              {/* <button className="dropdown-toggle" type="button" id="dropdownMenuButtonGrade" data-bs-toggle="dropdown" aria-expanded="false" style={{ paddingLeft: "2rem" }}>
                Grade
              </button> */}
              <ul className="dropdown-menu" aria-labelledby="dropdownMenuButtonGrade">
                <button className={`dropdown-item`} name="grade" value="showAllGrade" onClick={() => setSearchFilter({ ...searchFilter, userGrade: { id: "", name: "" } })} >
                  All
                </button>
                {dropDownList.grade.map((grade: IdAndName, index: number) => (
                  <li key={grade.id}>
                    <button className={`dropdown-item ${searchFilter.userGrade.id === grade.id ? "active" : ""}`} name="grade" value={grade.name} onClick={() => setSearchFilter({ ...searchFilter, userGrade: { id: grade.id, name: grade.name } })} >
                      {grade.name}
                    </button>
                  </li>
                ))}
              </ul>



              {searchFilter.userGrade.id &&
                <span className="badge rounded-pill" style={{ marginLeft: '1rem', background: '#782ACB' }}>{searchFilter.userGrade.name}
                  <span className='ps-2' style={{ cursor: 'pointer' }}><img src="./assets/images/xmark-solid.svg" alt="" onClick={() => removeFilterBox("activeUserGrade")} /></span></span>
              }


            </div>
            <div className="ms-2 searchInputDashboard">
              <input type="text" placeholder="Search" name="searchText" value={searchtext.userSearchText} onChange={(e: any) => handleUserSearch(e, "searchText", searchtext.userSearchText, searchFilter.userRole)} />
            </div>
          </div>
          {loading.userLoader ? ( // Show loader when loading is true
            <div className=' d-flex align-items-center'>
              <div className="loader mx-auto"></div>
            </div>
          ) :
            tableData.userData.length > 0 ?
              <div className='table-responsive '>
                <table className="table table-bordered" id='table_with_user_data'>
                  <thead>
                    <tr>
                      {/* <th>FULL NAME</th> */}
                      <th>EMAIL</th>
                      {/* <th className='text-center'>USERNAME</th> */}
                      <th className='text-center'>ROLE</th>
                      <th className='text-center'>SCHOOL DISTRICT</th>
                      {/* <th className='text-center'>GRADE</th> */}
                      <th className='text-center'>CREATED AT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.userData.map((user: UserDataType) => (
                      <tr key={user.id}>
                        {/* <td>{user.fname}</td> */}
                        <td>
                          <span data-tooltip-id={`tooltip-email-${user.id}`} data-tooltip-content={user.email} data-tooltip-place="top" >
                            {user.email.length > 10 ? user.email.substring(0, 10) + "..." : user.email}
                          </span>
                          {user.email.length > 10 && <Tooltip id={`tooltip-email-${user.id}`} />}
                        </td>
                        {/* <td className='text-center'>{user.username}</td> */}
                        <td className='text-center'>{user.role}</td>
                        {user.school_district.name ?
                          <td className="text-center">
                            <span data-tooltip-id={`tooltip-user-school-district-${user.id}`} data-tooltip-content={user.school_district.name} data-tooltip-place="top" >
                              {user.school_district.name.length > 12 ? user.school_district.name.substring(0, 12) + "..." : user.school_district.name}
                            </span>
                            {user.school_district.name.length > 12 && <Tooltip id={`tooltip-user-school-district-${user.id}`} />}
                          </td>
                          :
                          <td className='text-center'>-</td>
                        }
                        {/* {user.grade.gradeId ?
                          <td className='text-center'>{user.grade.gradeId === "1" ? user.grade.gradeName.substring(0, 6) : user.grade.gradeName}</td> :
                          <td className='text-center'>-</td>
                        } */}

                        <td className='text-center'>{new Date(user.createdAt).toLocaleDateString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              :
              <p className="text-center mt-5">No Data Found</p>
          }
          {/* Pagination Controls */}
          <div className="pagination-container">

            <nav className='d-flex justify-content-between align-items-center'>
              <div className='page-length'>
                Showing {Math.min(indexOfFirstUserItem + 1, totalCount.userTotalCount)} - {Math.min(indexOfLastUserItem, totalCount.userTotalCount)} of {totalCount.userTotalCount}
              </div>
              <ul className="pagination justify-content-center mx-auto">
                <li className="page-item">
                  <button className="page-link" onClick={() => handlePagination(currentUserPage - 1, "left", "User")} aria-label="Previous">
                    <span aria-hidden="true"><img src="assets/images/arrow-left-small.svg" alt="" /></span>
                  </button>
                </li>
                <li className="page-item disabled">
                  <span className="page-link">
                    {indexOfFirstUserItem + 1} of {indexOfLastUserItem}
                  </span>
                </li>
                <li className="page-item">
                  <button className="page-link" onClick={() => handlePagination(currentUserPage + 1, "right", "User")} aria-label="Next" >
                    <span aria-hidden="true"><img src="assets/images/arrow-right-small.svg" alt="" /></span>
                  </button>
                </li>
              </ul>

              <div>
                <button className='bg-transparent' onClick={downloadUserTable}>
                  <img src="./assets/images/download-M.svg" alt="" />
                </button>
                <button className='bg-transparent'>
                  <img src="./assets/images/arrow-reload.svg" alt="" />
                </button>
              </div>
            </nav>
          </div>
        </div>

        <div className="pCard mb-4">
          <div className="topAction align-items-center">
            <h5 style={{ color: "#333232" }}>Active Student</h5>
            <div className="dropdown statusDrop ms-auto" >

              <button className="dropdown-toggle" type="button" id="dropdownMenuButtonGrade" data-bs-toggle="dropdown" aria-expanded="false" style={{ paddingLeft: "2rem" }}>
                {/* {activeFilter.grade.id ? activeFilter.grade.name : "Grade"} */}
                Grade
              </button>
              <ul className="dropdown-menu" aria-labelledby="dropdownMenuButtonGrade">
                <button className={`dropdown-item`} name="grade" value="showAllGrade" onClick={() => setSearchFilter({ ...searchFilter, studentGrade: { id: "", name: "" } })} >
                  All
                </button>
                {dropDownList.grade.map((grade: IdAndName, index: number) => (
                  <li key={grade.id}>
                    <button className={`dropdown-item ${searchFilter.studentGrade.id === grade.id ? "active" : ""}`} name="grade" value={grade.name} onClick={() => setSearchFilter({ ...searchFilter, studentGrade: { id: grade.id, name: grade.name } })} >
                      {grade.name}
                    </button>
                  </li>
                ))}
              </ul>



              {searchFilter.studentGrade.id &&
                <span className="badge rounded-pill" style={{ marginLeft: '1rem', background: '#782ACB' }}>{searchFilter.studentGrade.name}
                  <span className='ps-2' style={{ cursor: 'pointer' }}><img src="./assets/images/xmark-solid.svg" alt="" onClick={() => setSearchFilter({ ...searchFilter, studentGrade: { id: "", name: "" } })} /></span></span>
              }
            </div>
            <div className="ms-2 searchInputDashboard">
              <input type="text" placeholder="Search" name="searchText" value={searchtext.studentSearchText} onChange={(e: any) => handleStudentSearch(e, "searchText", searchtext.studentSearchText, searchFilter.studentRole)} autoComplete='false' />
            </div>
          </div>


          {loading.studentLoader ?
            <div className=" d-flex align-items-center">
              <div className="loader mx-auto"></div>
            </div>
            :
            (tableData.studentData.length > 0 ?
              <div className="table-responsive">
                <table className="table table-bordered" id='table_with_student_data'>
                  <thead>
                    <tr>
                      <th>FULL NAME</th>
                      <th>SCHOOL DISTRICT</th>
                      <th>GRADE</th>
                      <th className='text-center'>USERNAME</th>
                      {/* <th className='text-center'>ROLE</th> */}
                      <th className='text-center'>CREATED AT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.studentData.map((student: StudentDataType) => (
                      <tr key={student.id}>
                        <td>{student.fname}</td>
                        {student.schoolDistrict.name ?
                          <td>
                            <span data-tooltip-id={`tooltip-user-school-district-${student.id}`} data-tooltip-content={student.schoolDistrict.name} data-tooltip-place="top" >
                              {student.schoolDistrict.name.length > 12 ? student.schoolDistrict.name.substring(0, 12) + "..." : student.schoolDistrict.name}
                            </span>
                            {student.schoolDistrict.name.length > 12 && <Tooltip id={`tooltip-user-school-district-${student.id}`} />}
                          </td>
                          :
                          <td style={{ paddingLeft: "4%" }}>-</td>
                        }
                        <td>{student.grade.gradeId === "1" ? student.grade.gradeName.substring(0, 6) : student.grade.gradeName.substring(0, 7)}</td>
                        <td className='text-center'>{student.username}</td>
                        {/* <td className='text-center'>{student.role}</td> */}
                        <td className='text-center'>{new Date(student.createdAt).toLocaleDateString()}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              :
              <p className="text-center mt-5">No Data Found</p>
            )}

          <div className="pagination-container">
            <nav className='d-flex justify-content-between align-items-center'>
              <div className='page-length'>
                Showing {Math.min(indexOfFirstStudentItem + 1, totalCount.studentTotalCount)} - {Math.min(indexOfLastStudentItem, totalCount.studentTotalCount)} of {totalCount.studentTotalCount}
              </div>
              <ul className="pagination justify-content-center mx-auto">
                <li className="page-item">
                  <button className="page-link" onClick={() => handlePagination(currentStudentPage - 1, "left", "Student")} aria-label="Previous">
                    <span aria-hidden="true"><img src="assets/images/arrow-left-small.svg" alt="" /></span>
                  </button>
                </li>
                <li className="page-item disabled">
                  <span className="page-link">
                    {indexOfFirstStudentItem + 1} of {indexOfLastStudentItem}
                  </span>
                </li>
                <li className="page-item">
                  <button className="page-link" onClick={() => handlePagination(currentStudentPage + 1, "right", "Student")} aria-label="Next" >
                    <span aria-hidden="true"><img src="assets/images/arrow-right-small.svg" alt="" /></span>
                  </button>
                </li>
              </ul>

              <div>
                <button className='bg-transparent' onClick={downloadStudentTable}>
                  <img src="./assets/images/download-M.svg" alt="" />
                </button>
                <button className='bg-transparent'>
                  <img src="./assets/images/arrow-reload.svg" alt="" />
                </button>
              </div>
            </nav>
          </div>
        </div>

        <div className="pCard mb-4">

          <div className="topAction align-items-center">
            <h5>Active Grade</h5>
            <div className="ms-auto dropdown statusDrop">
            </div>
            <div className="ms-auto searchInputDashboard">
              <input type="text" placeholder="Search" name="searchText" value={searchtext.gradeSearchText} onChange={handleGradeSearch} autoComplete='false' />
            </div>

            <button className="btn add-btn btnPurple w-auto px-3" onClick={handleAddGrade}>+</button>
          </div>
          {loading.gradeLoader ?
            <div className=" d-flex align-items-center">
              <div className="loader mx-auto"></div>
            </div>
            :
            (tableData.gradeData.length > 0 ?
              <div className="table-responsive">
                <table className="table table-bordered" id='table_with_student_data'>
                  <thead>
                    <tr>
                      {/* <th>S.No.</th> */}
                      <th>GRADE NAME</th>
                      <th className='text-center'># LESSONS</th>
                      <th className='text-center'># UNITS</th>
                      <th className='text-center'>CREATED AT</th>

                      <th className='text-center'>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.gradeData.map((grade: TableGradeDataType, index: number) => (
                      <tr key={grade.id}>
                        <td>{grade.gradeName}</td>
                        <td className="text-center">{grade.lessonCount}</td>
                        <td className="text-center">{grade.unitCount}</td>
                        <td className="text-center">
                          {new Date(grade.createdAt).toLocaleDateString()}
                        </td>
                        <td className="text-center">
                          <div className="dropdown dots">
                            <button className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                              <img src='./assets/images/more.svg' alt='action button' />
                            </button>

                            <ul className="dropdown-menu">
                              <li>
                                <button className="dropdown-item" onClick={() => handleGradeEdit(grade)}>
                                  <img src="./assets/images/edit-icon.png" alt="" className="me-2" />
                                  Edit
                                </button>
                              </li>

                              {Number(grade.lessonCount) < 1 && (
                                <li>
                                  <button className="dropdown-item" onClick={() => handleGradeDelete(grade)}>
                                    <img src="./assets/images/delete.png" alt="" className="me-2" />
                                    Delete
                                  </button>
                                </li>
                              )}
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))}

                  </tbody>
                </table>
              </div>
              :
              <p className="text-center mt-5">No Data Found</p>
            )}

          <div className="pagination-container">
            <nav className='d-flex justify-content-between align-items-center'>
              <div className='page-length'>
                Showing {Math.min(indexOfFirstGradeItem + 1, totalCount.gradeTotalCount)} - {Math.min(indexOfLastGradeItem, totalCount.gradeTotalCount)} of {totalCount.gradeTotalCount}
              </div>
              <ul className="pagination justify-content-center mx-auto">
                <li className="page-item">
                  <button className="page-link" onClick={() => handlePagination(currentGradePage - 1, "left", "Grade")} aria-label="Previous">
                    <span aria-hidden="true"><img src="assets/images/arrow-left-small.svg" alt="" /></span>
                  </button>
                </li>
                <li className="page-item disabled">
                  <span className="page-link">
                    {indexOfFirstGradeItem + 1} of {indexOfLastGradeItem}
                  </span>
                </li>
                <li className="page-item">
                  <button className="page-link" onClick={() => handlePagination(currentGradePage + 1, "right", "Grade")} aria-label="Next" >
                    <span aria-hidden="true"><img src="assets/images/arrow-right-small.svg" alt="" /></span>
                  </button>
                </li>
              </ul>

              {/* <div>
                <button className='bg-transparent'>
                  <img src="./assets/images/download-M.svg" alt="" />
                </button>
                <button className='bg-transparent'>
                  <img src="./assets/images/arrow-reload.svg" alt="" />
                </button>
              </div> */}
            </nav>
          </div>
        </div>
      </div>
      {show &&
        <ConfirmationPopup
          title={confirmationPopupData.title}
          message={confirmationPopupData.message}
          isBackIterated={true}
          descriptions={confirmationPopupData.descriptions}
          acceptText={confirmationPopupData.acceptText}
          cancelText={confirmationPopupData.cancelText}
          onAccept={confirmationPopupData.onAccept}
          onCancel={confirmationPopupData.onCancel}
          onCrossClick={confirmationPopupData.onCancel}
        />
      }
    </div>
  );
}

export default Dashboard